
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps",
      function () {
        return require("private-next-pages/apps/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps"])
      });
    }
  